import UseCasesIcon from '@icons/UseCasesIcon.svg';
import RetentionIcon from '@icons/RetentionIcon.svg';
import TrendingIcon from '@icons/trend.svg';
import type { UseCasesWhyHowBlock } from '@components/widgets';

export const PEOS_USE_CASES_WHY_HOW_SECTION_TITLE =
    'Why Predictable Benefits for PEOs';

export const PEOS_USE_CASES_WHY_HOW_BLOCKS: UseCasesWhyHowBlock[] = [
    {
        pillNavLabel: 'Capture High-Risk Clients',
        title: 'Capturing the "Un-insurable" or High-Risk Client Segment',
        description:
            'Traditional PEO models often struggle with clients who have high loss ratios or those in "risky" industries that face massive annual renewals.',
        cards: [
            {
                iconSrc: UseCasesIcon,
                title: 'The Use Case',
                description:
                    'Instead of offboarding a client due to a 30% renewal increase, the PEO can pivot them to an ICHRA.',
            },
            {
                iconSrc: TrendingIcon,
                title: 'Growth Impact',
                description:
                    'PEOs can prospect "high-risk" companies they previously would have declined, offering them a defined-contribution model that removes the PEO’s exposure to the clients medical claims.',
            },
            {
                iconSrc: RetentionIcon,
                title: 'Retention Impact',
                description:
                    'Keeps the client within the PEO ecosystem (Payroll, HR, Workers’ Comp) even when a traditional Master Policy is no longer viable.',
            },
        ],
    },
    {
        pillNavLabel: 'Support Remote Teams',
        title: 'Geographically Dispersed & Remote Workforces',
        description:
            'Master health plans often have "dead zones" where provider networks are weak, frustrating remote employees.',
        cards: [
            {
                iconSrc: UseCasesIcon,
                title: 'The Use Case',
                description:
                    'For a client with employees spread across 20 states, a single group plan is rarely "best-in-class" for everyone. Using the Predictable Benefits platform, each employee shops in their local exchange for the network that actually works in their zip code.',
            },
            {
                iconSrc: TrendingIcon,
                title: 'Growth Impact',
                description:
                    'PEOs can more effectively compete for national accounts and tech-forward "work-from-anywhere" companies.',
            },
        ],
    },
    {
        pillNavLabel: 'Offer Class-Based Plans',
        title: 'Strategic "Class-Based" Carve-Outs',
        description:
            'PEOs often operate on an "all-or-nothing" group health model. ICHRA allows for surgical precision.',
        cards: [
            {
                iconSrc: UseCasesIcon,
                title: 'The Use Case',
                description:
                    'A PEO client may want to keep executives on the Master Group Plan but finds it too expensive to cover part-time, or seasonal workers. The PEO can offer an ICHRA specifically for these classes.',
            },
            {
                iconSrc: TrendingIcon,
                title: 'Growth Impact',
                description:
                    'Opens up revenue streams from employee segments (part-time/seasonal) that were previously excluded from the PEO’s benefit billing.',
            },
        ],
    },
    {
        pillNavLabel: 'White-Label Your Platform',
        title: 'Brand Consolidation via White-Labeling',
        description:
            'The Predictable Benefits white-label feature ensures the PEO remains the "hero" of the story.',
        cards: [
            {
                iconSrc: UseCasesIcon,
                title: 'The Use Case',
                description:
                    'The PEO integrates the platform so it looks and feels like a native part of their proprietary HRIS.',
            },
            {
                iconSrc: RetentionIcon,
                title: 'Retention Impact',
                description:
                    'By maintaining a single brand experience, the PEO increases "stickiness." The client views the ICHRA not as a third-party tool, but as a core value-add of their PEO partnership.',
            },
        ],
    },
    {
        pillNavLabel: 'Remove Participation Limits',
        title: 'Eliminating Participation Hurdles',
        description:
            'Small to mid-sized businesses often fail to meet the participation requirements of group plans because many employees are on a spouses plan or Medicaid.',
        cards: [
            {
                iconSrc: UseCasesIcon,
                title: 'The Use Case',
                description:
                    'A PEO can save a deal where only 40% of the workforce wants to enroll. Because ICHRA has no minimum participation requirements, the PEO can still provide a compliant benefit and collect its administrative fees.',
            },
            {
                iconSrc: RetentionIcon,
                title: 'Retention Impact',
                description:
                    'Prevents "group breakup" where a client leaves the PEO because they can no longer qualify for the health insurance tier.',
            },
        ],
    },
];
